module.exports = __webpack_public_path__ + "images/2c6904f1b5d4578b265674b90ff40782.jpg";